/**
 * The name of the closeCurrentModal action.
 */
export const closeCurrentModalActionName = 'closeCurrentModal'
